export default __webpack_public_path__ + "static/media/undraw_file_searching.6fa898d5.svg";